import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const CurrencySelector = ({ selectedCurrency, availableCurrencies = ['USD', 'EUR', 'BRL'], onCurrencyChange }) => {
  const [currency, setCurrency] = useState(selectedCurrency || availableCurrencies[0]);

  const handleChange = (event) => {
    const selected = event.target.value;
    setCurrency(selected);
    if (onCurrencyChange) {
      onCurrencyChange(selected);
    }
  };

  return (
    <FormControl fullWidth sx={{ minWidth: 150 }}>
      <InputLabel id="currency-select-label">Currency</InputLabel>
      <Select
        labelId="currency-select-label"
        value={currency}
        label="Currency"
        onChange={handleChange}
      >
        {availableCurrencies.map((cur) => (
          <MenuItem key={cur} value={cur}>
            {cur}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencySelector;